// tslint:disable
export enum CoveragedetCoverageStatus {
    /**
     * @description Other/Unknown/Error determining the coverage status. See Coverage Status Text for details
     */
    Unknown = 0,
    /**
     * @description CoveredWithRestrictions
     */
    CoveredWithRestrictions = 1,
    /**
     * @description Covered
     */
    Covered = 2,
    /**
     * @description ErrorProcessingPharmacyType
     */
    ErrorProcessingPharmacyType = 3,
    /**
     * @description NotCovered
     */
    NotCovered = 4,
}
(CoveragedetCoverageStatus as any)['UNKNOWN'] = 0;
(CoveragedetCoverageStatus as any)['COVEREDWITHRESTRICTIONS'] = 1;
(CoveragedetCoverageStatus as any)['COVERED'] = 2;
(CoveragedetCoverageStatus as any)['ERRORPROCESSINGPHARMACYTYPE'] = 3;
(CoveragedetCoverageStatus as any)['NOTCOVERED'] = 4;
